import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {WorkspaceService} from "../services/workspace.service";
import {PermissionSection} from "../interfaces/user/permissions.type";

/**
 * On the `workspace/:workspaceId` parent it only refreshes the current user's permissions for
 * that workspace; on a section route (`data.section`) it also gates access, so a menu item
 * hidden by permissions can't be reached by typing the URL either.
 */
export const permissionGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const workspaceSvc = inject(WorkspaceService)
  const router = inject(Router)

  const workspaceId = route.paramMap.get('workspaceId')
  if (workspaceId) { await workspaceSvc.ensureRole(workspaceId) }

  const section = route.data['section'] as PermissionSection | undefined
  if (!section) { return true }

  await workspaceSvc.waitForPermissions()
  if (workspaceSvc.can(section)) { return true }
  return router.createUrlTree(['/workspace', workspaceSvc.workspaceId, 'overview'])
}
